import React from 'react';

import illustrationMoverWithSixteenFootTruck from '@images/illustrations/mover_with_sixteen_foot_truck.svg';
import illustrationOnlinePhotoCatalog from '@images/illustrations/online_photo_catalog_large.svg';
import illustrationOnlineQuote from '@images/illustrations/online_quote.svg';

import { InfoCardItem } from './info_card_item';
import { InfoCardList } from './info_card_list';

export const HowClutterMovingWorks = () => (
  <InfoCardList title="Moving with Clutter">
    <InfoCardItem
      label="1"
      title="Get an easy online quote"
      subtitle="Get a quote and lock in your move date in minutes, with affordable and transparent pricing."
      icon={illustrationOnlineQuote}
    />
    <InfoCardItem
      label="2"
      title="Enjoy your easiest-ever move"
      subtitle="Relax! Our professional movers handle it all, including packing, wrapping, and transporting your belongings."
      icon={illustrationMoverWithSixteenFootTruck}
    />
    <InfoCardItem
      label="3"
      title="Manage your move online"
      subtitle="Moving meets technology! Just pull out your phone to meet your movers, track your truck, and get answers to last-minute questions."
      icon={illustrationOnlinePhotoCatalog}
    />
  </InfoCardList>
);
